import { render, staticRenderFns } from "./studentCreatePlanLayout.vue?vue&type=template&id=0d907cb3&scoped=true"
import script from "./studentCreatePlanLayout.vue?vue&type=script&lang=js"
export * from "./studentCreatePlanLayout.vue?vue&type=script&lang=js"
import style0 from "./studentCreatePlanLayout.vue?vue&type=style&index=0&id=0d907cb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d907cb3",
  null
  
)

export default component.exports